<template>
  <div class="space-y-3">
    <div v-if="title" class="text-md font-semibold text-gray-800 mb-2">{{ title }}</div>
    <div v-if="consistencyData && Object.keys(consistencyData).length > 0">
      <div v-for="(item, key) in formattedConsistencyData" :key="key" class="p-3 bg-gray-50 rounded-md shadow-sm">
        <div class="flex justify-between items-center">
          <span class="text-sm font-medium text-gray-700">{{ item.label }}:</span>
          <span 
            class="text-sm font-semibold px-2 py-0.5 rounded-full"
            :class="item.consistent ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'"
          >
            {{ item.status }}
          </span>
        </div>
        <div v-if="!item.consistent && item.details" class="mt-1 text-xs text-gray-600">
          <p><span class="font-medium">Expected:</span> {{ item.details.expected }}</p>
          <p><span class="font-medium">Found:</span> {{ item.details.found }}</p>
        </div>
        <div v-if="item.value" class="mt-1 text-xs text-gray-600">
          {{ item.value }}
        </div>
      </div>
    </div>
    <div v-else class="text-sm text-gray-500 italic">
      {{ emptyText }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'NapConsistencyDisplay',
  props: {
    consistencyData: { // Expects an object e.g., { name: { consistent: true, value: 'ACME Corp'}, address: {...} }
      type: Object,
      default: () => ({})
    },
    title: {
      type: String,
      default: 'NAP Consistency'
    },
    emptyText: {
      type: String,
      default: 'NAP consistency data not available'
    }
  },
  computed: {
    formattedConsistencyData() {
      if (!this.consistencyData) return [];
      const order = ['name', 'address', 'phone'];
      const formatted = [];
      
      for (const key of order) {
        if (this.consistencyData[key]) {
          const item = this.consistencyData[key];
          formatted.push({
            key: key,
            label: this.formatKey(key),
            consistent: item.consistent === true || item.status === 'Consistent', // handle various ways consistency might be expressed
            status: (item.consistent === true || item.status === 'Consistent') ? 'Consistent' : 'Inconsistent',
            value: item.value || null,
            details: item.details || null
          });
        }
      }
      // Add any other keys not in the predefined order
      for (const key in this.consistencyData) {
        if (!order.includes(key)) {
           const item = this.consistencyData[key];
           formatted.push({
            key: key,
            label: this.formatKey(key),
            consistent: item.consistent === true || item.status === 'Consistent',
            status: (item.consistent === true || item.status === 'Consistent') ? 'Consistent' : 'Inconsistent',
            value: item.value || null,
            details: item.details || null
          });
        }
      }
      return formatted;
    }
  },
  methods: {
    formatKey(key) {
      const s = key.replace(/_/g, ' ');
      return s.charAt(0).toUpperCase() + s.slice(1);
    }
  }
};
</script>

<style scoped>
/* Scoped styles */
</style> 